/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Shop_Home_Row_EditorInputs */

const vi_shop_home_row_editor = /** @type {(inputs: Shop_Home_Row_EditorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dòng ${i?.n}`)
};

/**

* @param {Shop_Home_Row_EditorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_row_editor = /** @type {((inputs: Shop_Home_Row_EditorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Row_EditorInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_row_editor(inputs)
});